import React from 'react'
import BlogPost, { BlogPostType } from '../../components/BlogPost'
import post from '../../data/blog/lucidne-snivanie'
import { language } from '../../global'

const LucidneSnivanie: React.FC = () => {
  return <BlogPost post={post[language as keyof typeof post] as BlogPostType} />
}

export default LucidneSnivanie
